<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="300px" spinnerName="simpleSignupLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      @if (newFenderUserCreated) {
        <div class="col-md-12 m-b-20">
          <fui-heading level="5" textAlign="center" [text]="'link_accounts.one_login_for_all' | translate"></fui-heading>
          <div class="d-flex align-items-center justify-content-center m-t-20">
            <myp-svg id="fender-logo" class="svg-neutral" width="100" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <!-- <myp-svg id="fender-studio-logo" class="svg-neutral" width="130" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div> -->
            <myp-svg id="presonus-logo" class="svg-neutral" width="100" height="30"></myp-svg>
          </div>
          <br />
          <br />
          <p [innerHTML]="'login_updates.nothing_to_change' | translate"></p>
        </div>
      }
      @if (userAlreadyMigrated) {
        <div class="col-md-12 m-b-20">
          <fui-heading level="5" textAlign="center" [text]="'link_accounts.one_login_for_all' | translate"></fui-heading>
          <div class="d-flex align-items-center justify-content-center m-t-20">
            <myp-svg id="fender-logo" class="svg-neutral" width="100" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <!-- <myp-svg id="fender-studio-logo" class="svg-neutral" width="130" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div> -->
            <myp-svg id="presonus-logo" class="svg-neutral" width="100" height="30"></myp-svg>
          </div>
          <br />
          <br />
          <div [innerHTML]="'login_updates.user_already_migrated' | translate"></div>
        </div>
      }
      @if (!userAlreadyMigrated && !newFenderUserCreated) {
        <div class="col-md-12 m-b-20">
          <fui-heading level="5" textAlign="center" [text]="'link_accounts.one_login_for_all' | translate"></fui-heading>
          <div class="d-flex align-items-center justify-content-center m-t-20">
            <myp-svg id="fender-logo" class="svg-neutral" width="100" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <myp-svg id="fender-studio-logo" class="svg-neutral" width="130" height="30"></myp-svg>
            <div class="m-x-20">&bull;</div>
            <myp-svg id="presonus-logo" class="svg-neutral" width="100" height="30"></myp-svg>
          </div>
          <br />
          <br />
          <p>
            {{ "login_updates.unifying_accounts" | translate: { email: email } }}
          </p>
          @if (loginMethod == "cognito") {
            <p [innerHTML]="'login_updates.to_connect_accounts' | translate"></p>
          }
          @if (loginMethod != "cognito") {
            <p>
              {{ "login_updates.login_method_choice" | translate: { loginMethod: loginMethod | sentenceCase, email: email } }}
            </p>
          }
          <div [innerHTML]="'login_updates.nothing_else_changing' | translate"></div>
          @if (loginMethod != "cognito") {
            <p>{{ "login_updates.click_link_below" | translate }}</p>
          }
        </div>
        @if (loginMethod == "cognito") {
          <div class="form-group col-md-12">
            <label class="control-label">{{ "profile.edit.email" | translate }}</label>
            <input type="text" (keyup.enter)="submit()" class="form-control" [(ngModel)]="email" />
          </div>
          <div class="form-group col-md-12">
            <label class="control-label">{{ "general.password" | translate }}</label>
            <input [type]="passwordVisible ? 'text' : 'password'" (keyup.enter)="submit()" class="form-control" [(ngModel)]="password" />
          </div>
          <div class="col-md-12">
            <myp-switch [active]="passwordVisible" label="Show password" [labelToRight]="true" (toggle)="passwordVisible = !passwordVisible"></myp-switch>
          </div>
          <div class="text-left m-t-20 col-md-12">
            <span class="link bold t-12" data-cy="forgot-password-link" (click)="startForgotPassword()">{{ "profile.need_help_signing_in" | translate }}</span>
          </div>
        }
        <div class="m-t-20 col-md-12 d-flex justify-content-between">
          @if (loginMethod == "google") {
            <button type="button" class="btn btn-secondary flex-grow-1 p-y-20 d-flex justify-content-center" (click)="signInWith('Google')">
              <myp-svg id="google-logo" class="svg-white" width="20" height="20"></myp-svg>
            </button>
          }
          @if (loginMethod == "facebook") {
            <button type="button" class="btn btn-secondary flex-grow-1 m-l-20 p-y-20 d-flex justify-content-center" (click)="signInWith('Facebook')">
              <myp-svg id="facebook-logo" class="svg-white" width="20" height="20"></myp-svg>
            </button>
          }
          @if (loginMethod == "apple") {
            <button type="button" class="btn btn-secondary flex-grow-1 m-l-20 p-y-20 d-flex justify-content-center" (click)="signInWith('Apple')">
              <myp-svg id="apple-logo" class="svg-white" width="20" height="20"></myp-svg>
            </button>
          }
        </div>
        @if (errorMessage) {
          <div class="col-md-12 text-center">
            <div class="api-error-message">{{ errorMessage }}</div>
          </div>
        }
      }
    </div>
  }
</div>
@if (!loading) {
  <div class="modal-footer">
    @if (loginMethod == "cognito" && !userAlreadyMigrated) {
      <button type="button" class="btn btn-primary" (click)="submit()">{{ "onboarding.login" | translate }}</button>
    }
    <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
}
